var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuarantee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 6.92254V8.68604H15.75V16.2439C15.75 16.3775 15.6973 16.5057 15.6036 16.6002C15.5098 16.6947 15.3826 16.7478 15.25 16.7478H2.75C2.61739 16.7478 2.49021 16.6947 2.39645 16.6002C2.30268 16.5057 2.25 16.3775 2.25 16.2439V8.68604H1.25V6.92254L8.7025 1.34987C8.78859 1.28564 8.89288 1.25098 9 1.25098C9.10712 1.25098 9.2114 1.28564 9.2975 1.34987L16.75 6.92254Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9.19043H6.75V13.9771H5.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.6942H7.25C7.455 9.59594 8.18 9.09713 8.25 8.93841C8.45 8.48746 8.95 7.37393 9.0825 6.90282C9.14807 6.57079 9.15568 6.22978 9.105 5.89511C9.09379 5.79575 9.11145 5.69525 9.15583 5.60581C9.2002 5.51637 9.2694 5.44183 9.355 5.39125C9.46924 5.30749 9.6113 5.2717 9.75122 5.29144C9.89113 5.31118 10.018 5.3849 10.105 5.49706C10.3139 5.72475 10.4514 6.00962 10.5 6.31583C10.6109 7.11475 10.525 7.92889 10.25 8.68648H12.375C12.5408 8.68648 12.6997 8.75284 12.8169 8.87095C12.9342 8.98907 13 9.14926 13 9.3163C13 9.48334 12.9342 9.64354 12.8169 9.76165C12.6997 9.87977 12.5408 9.94612 12.375 9.94612H12C12.0425 9.94612 12.21 9.94613 12.25 9.95872C12.4019 9.9898 12.5369 10.0766 12.6288 10.2024C12.7208 10.3282 12.763 10.4838 12.7475 10.6392C12.7319 10.7946 12.6596 10.9387 12.5445 11.0434C12.4295 11.148 12.28 11.2059 12.125 11.2058H11.875C11.917 11.2061 11.9588 11.2103 12 11.2184C12.1519 11.2494 12.2869 11.3363 12.3788 11.462C12.4708 11.5878 12.513 11.7435 12.4975 11.8989C12.4819 12.0543 12.4096 12.1983 12.2945 12.303C12.1795 12.4077 12.03 12.4656 11.875 12.4654H11.625C11.7908 12.4654 11.9497 12.5318 12.0669 12.6499C12.1842 12.768 12.25 12.9282 12.25 13.0952C12.25 13.2623 12.1842 13.4225 12.0669 13.5406C11.9497 13.6587 11.7908 13.7251 11.625 13.7251H9L8 13.4731H7",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuarantee);
export default __webpack_public_path__ + "static/media/guarantee.de8109de.svg";
export { ForwardRef as ReactComponent };